import { Compounds } from "#/declarations";

export const MASS_TABLE: { [id: string]: number } = {
  H: 1.00794,
  C: 12.0107,
  O: 15.9994,
  N: 14.0067,
  OH: 17.00734,
  HO: 17.00734,
  S: 32.065,
  Si: 28.0855,
  P: 30.973762,
  NH: 15.01464,
  HN: 15.01464,
  "H₃C": 15.03452,
  "CH₃": 15.03452,
  F: 18.998403,
  Cl: 35.453,
  Br: 79.904,
  I: 126.90447,
  "NO₂": 46.0055,
  R: 0,
};

export const STRUCTURES: { [id: string]: Compounds.Structure } = {
  "aromatic-ring": {
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "c3", name: "C" },
      { id: "c4", name: "C" },
      { id: "c5", name: "C" },
      { id: "c6", name: "C" },
      { id: "h1", name: "H" },
      { id: "h2", name: "H" },
      { id: "h3", name: "H" },
      { id: "h4", name: "H" },
      { id: "h5", name: "H" },
      { id: "h6", name: "H" },
    ],
    bonds: [
      { id: "c1-h1", source: "c1", target: "h1", type: 1 },
      { id: "c1-c2", source: "c1", target: "c2", type: 2 },
      { id: "c2-h2", source: "c2", target: "h2", type: 1 },
      { id: "c2-c3", source: "c2", target: "c3", type: 1 },
      { id: "c3-h3", source: "c3", target: "h3", type: 1 },
      { id: "c3-c4", source: "c3", target: "c4", type: 2 },
      { id: "c4-h4", source: "c4", target: "h4", type: 1 },
      { id: "c4-c5", source: "c4", target: "c5", type: 1 },
      { id: "c5-h5", source: "c5", target: "h5", type: 1 },
      { id: "c5-c6", source: "c5", target: "c6", type: 2 },
      { id: "c6-h6", source: "c6", target: "h6", type: 1 },
      { id: "c6-c1", source: "c6", target: "c1", type: 1 },
    ],
  },
  "aromatic-ring-empty": {
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "c3", name: "C" },
      { id: "c4", name: "C" },
      { id: "c5", name: "C" },
      { id: "c6", name: "C" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
      { id: "r4", name: "R" },
      { id: "r5", name: "R" },
      { id: "r6", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-c2", source: "c1", target: "c2", type: 2 },
      { id: "c2-r2", source: "c2", target: "r2", type: 1 },
      { id: "c2-c3", source: "c2", target: "c3", type: 1 },
      { id: "c3-r3", source: "c3", target: "r3", type: 1 },
      { id: "c3-c4", source: "c3", target: "c4", type: 2 },
      { id: "c4-r4", source: "c4", target: "r4", type: 1 },
      { id: "c4-c5", source: "c4", target: "c5", type: 1 },
      { id: "c5-r5", source: "c5", target: "r5", type: 1 },
      { id: "c5-c6", source: "c5", target: "c6", type: 2 },
      { id: "c6-r6", source: "c6", target: "r6", type: 1 },
      { id: "c6-c1", source: "c6", target: "c1", type: 1 },
    ],
  },
  "o-aromatic-ring-empty": {
    //Yes, this looks horrifying.
    //No, there isn't a better way to do this without replacing the renderer
    //Pentagons, man
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "c3", name: "C" },
      { id: "c4", name: "C" },
      { id: "o1", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
      { id: "r4", name: "R" },
      { id: "p1", name: "" },
      { id: "p2", name: "" },
      { id: "p3", name: "" },
      { id: "p4", name: "" },
      { id: "p5", name: "" },
      { id: "p6", name: "" },
      { id: "p7", name: "" },
      { id: "p8", name: "" },
      { id: "p9", name: "" },
      { id: "p10", name: "" },
      { id: "p11", name: "" },
      { id: "p12", name: "" },
      { id: "p13", name: "" },
      { id: "p14", name: "" },
      { id: "p15", name: "" },
      { id: "p16", name: "" },
      { id: "p17", name: "" },
      { id: "p18", name: "" },
      { id: "p19", name: "" },
      { id: "p20", name: "" },
      { id: "p21", name: "" },
      { id: "p22", name: "" },
      { id: "p23", name: "" },
      { id: "p24", name: "" },
      { id: "p25", name: "" },
      { id: "p26", name: "" },
      { id: "p27", name: "" },
      { id: "p28", name: "" },
      { id: "p29", name: "" },
      { id: "p30", name: "" },
      { id: "p31", name: "" },
      { id: "p32", name: "" },
      { id: "p33", name: "" },
      { id: "p34", name: "" },
      { id: "p35", name: "" },
      { id: "p36", name: "" },
      { id: "p37", name: "" },
      { id: "p38", name: "" },
      { id: "p39", name: "" },
      { id: "p40", name: "" },
      { id: "p41", name: "" },
      { id: "p42", name: "" },
      { id: "p43", name: "" },
      { id: "p44", name: "" },
      { id: "p45", name: "" },
      { id: "p46", name: "" },
      { id: "p47", name: "" },
      { id: "p48", name: "" },
      { id: "p49", name: "" },
      { id: "p50", name: "" },
      { id: "p51", name: "" },
      { id: "p52", name: "" },
      { id: "p53", name: "" },
      { id: "p54", name: "" },
      { id: "p55", name: "" },
      { id: "p56", name: "" },
      { id: "p57", name: "" },
      { id: "p58", name: "" },
      { id: "p59", name: "" },
      { id: "p60", name: "" },
      { id: "p61", name: "" },
    ],
    bonds: [
      { id: "o1-p1", source: "o1", target: "p1", type: 0 },
      { id: "o1-p2", source: "o1", target: "p2", type: 0 },
      { id: "o1-p3", source: "o1", target: "p3", type: 0 },
      { id: "o1-c1", source: "o1", target: "c1", type: 1, multiplier: 2 },
      { id: "o1-p4", source: "o1", target: "p5", type: 0 },

      { id: "c1-p6", source: "c1", target: "p6", type: 0 },
      { id: "c1-p7", source: "c1", target: "p7", type: 0 },
      { id: "c1-p8", source: "c1", target: "p8", type: 0 },
      { id: "c1-p9", source: "c1", target: "p9", type: 0 },
      { id: "c1-p10", source: "c1", target: "p10", type: 0 },

      { id: "c1-r1", source: "c1", target: "r1", type: 1 },

      { id: "c1-p11", source: "c1", target: "p11", type: 0 },
      { id: "c1-p12", source: "c1", target: "p12", type: 0 },
      { id: "c1-p13", source: "c1", target: "p13", type: 0 },
      { id: "c1-p14", source: "c1", target: "p14", type: 0 },
      { id: "c1-p15", source: "c1", target: "p15", type: 0 },

      { id: "c1-c2", source: "c1", target: "c2", type: 2 },

      { id: "c1-p16", source: "c1", target: "p16", type: 0 },
      { id: "c1-p17", source: "c1", target: "p17", type: 0 },
      { id: "c1-p18", source: "c1", target: "p18", type: 0 },
      { id: "c1-p19", source: "c1", target: "p19", type: 0 },

      { id: "c2-p20", source: "c2", target: "p20", type: 0 },
      { id: "c2-p21", source: "c2", target: "p21", type: 0 },
      { id: "c2-p22", source: "c2", target: "p22", type: 0 },
      { id: "c2-p23", source: "c2", target: "p23", type: 0 },
      { id: "c2-p24", source: "c2", target: "p24", type: 0 },

      { id: "c2-r2", source: "c2", target: "r2", type: 1 },

      { id: "c2-p25", source: "c2", target: "p25", type: 0 },
      { id: "c2-p26", source: "c2", target: "p26", type: 0 },
      { id: "c2-p27", source: "c2", target: "p27", type: 0 },
      { id: "c2-p28", source: "c2", target: "p28", type: 0 },
      { id: "c2-p29", source: "c2", target: "p29", type: 0 },

      { id: "c2-c3", source: "c2", target: "c3", type: 1 },

      { id: "c2-p30", source: "c2", target: "p30", type: 0 },
      { id: "c2-p31", source: "c2", target: "p31", type: 0 },
      { id: "c2-p32", source: "c2", target: "p32", type: 0 },
      { id: "c2-p33", source: "c2", target: "p33", type: 0 },

      { id: "c3-p34", source: "c3", target: "p34", type: 0 },
      { id: "c3-p35", source: "c3", target: "p35", type: 0 },
      { id: "c3-p36", source: "c3", target: "p36", type: 0 },
      { id: "c3-p37", source: "c3", target: "p37", type: 0 },
      { id: "c3-p38", source: "c3", target: "p38", type: 0 },

      { id: "c3-r3", source: "c3", target: "r3", type: 1 },

      { id: "c3-p39", source: "c3", target: "p39", type: 0 },
      { id: "c3-p40", source: "c3", target: "p40", type: 0 },
      { id: "c3-p41", source: "c3", target: "p41", type: 0 },
      { id: "c3-p42", source: "c3", target: "p42", type: 0 },
      { id: "c3-p43", source: "c3", target: "p43", type: 0 },

      { id: "c3-c4", source: "c3", target: "c4", type: 2 },

      { id: "c3-p44", source: "c3", target: "p44", type: 0 },
      { id: "c3-p45", source: "c3", target: "p45", type: 0 },
      { id: "c3-p46", source: "c3", target: "p46", type: 0 },
      { id: "c3-p47", source: "c3", target: "p47", type: 0 },

      { id: "c4-p48", source: "c4", target: "p48", type: 0 },
      { id: "c4-p49", source: "c4", target: "p49", type: 0 },
      { id: "c4-p50", source: "c4", target: "p50", type: 0 },
      { id: "c4-p51", source: "c4", target: "p51", type: 0 },
      { id: "c4-p52", source: "c4", target: "p52", type: 0 },

      { id: "c4-r4", source: "c4", target: "r4", type: 1 },

      { id: "c4-p53", source: "c4", target: "p53", type: 0 },
      { id: "c4-p54", source: "c4", target: "p54", type: 0 },
      { id: "c4-p55", source: "c4", target: "p55", type: 0 },
      { id: "c4-p56", source: "c4", target: "p56", type: 0 },
      { id: "c4-p57", source: "c4", target: "p57", type: 0 },

      { id: "c4-o1", source: "c4", target: "o1", type: 1, multiplier: 2 },

      { id: "c4-p58", source: "c4", target: "p58", type: 0 },
      { id: "c4-p59", source: "c4", target: "p59", type: 0 },
      { id: "c4-p60", source: "c4", target: "p60", type: 0 },
      { id: "c4-p61", source: "c4", target: "p61", type: 0 },
    ],
  },
  "n-aromatic-ring-empty": {
    //Yes, this looks horrifying.
    //No, there isn't a better way to do this without replacing the renderer
    //Pentagons, man
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "c3", name: "C" },
      { id: "c4", name: "C" },
      { id: "n1", name: "N" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
      { id: "r4", name: "R" },
      { id: "r5", name: "R" },
      { id: "p1", name: "" },
      { id: "p2", name: "" },
      { id: "p3", name: "" },
      { id: "p4", name: "" },
      { id: "p5", name: "" },
      { id: "p6", name: "" },
      { id: "p7", name: "" },
      { id: "p8", name: "" },
      { id: "p9", name: "" },
      { id: "p10", name: "" },
      { id: "p11", name: "" },
      { id: "p12", name: "" },
      { id: "p13", name: "" },
      { id: "p14", name: "" },
      { id: "p15", name: "" },
      { id: "p16", name: "" },
      { id: "p17", name: "" },
      { id: "p18", name: "" },
      { id: "p19", name: "" },
      { id: "p20", name: "" },
      { id: "p21", name: "" },
      { id: "p22", name: "" },
      { id: "p23", name: "" },
      { id: "p24", name: "" },
      { id: "p25", name: "" },
      { id: "p26", name: "" },
      { id: "p27", name: "" },
      { id: "p28", name: "" },
      { id: "p29", name: "" },
      { id: "p30", name: "" },
      { id: "p31", name: "" },
      { id: "p32", name: "" },
      { id: "p33", name: "" },
      { id: "p34", name: "" },
      { id: "p35", name: "" },
      { id: "p36", name: "" },
      { id: "p37", name: "" },
      { id: "p38", name: "" },
      { id: "p39", name: "" },
      { id: "p40", name: "" },
      { id: "p41", name: "" },
      { id: "p42", name: "" },
      { id: "p43", name: "" },
      { id: "p44", name: "" },
      { id: "p45", name: "" },
      { id: "p46", name: "" },
      { id: "p47", name: "" },
      { id: "p48", name: "" },
      { id: "p49", name: "" },
      { id: "p50", name: "" },
      { id: "p51", name: "" },
      { id: "p52", name: "" },
      { id: "p53", name: "" },
      { id: "p54", name: "" },
      { id: "p55", name: "" },
      { id: "p56", name: "" },
      { id: "p57", name: "" },
      { id: "p58", name: "" },
      { id: "p59", name: "" },
      { id: "p60", name: "" },
      { id: "p61", name: "" },
      { id: "p62", name: "" },
      { id: "p63", name: "" },
      { id: "p64", name: "" },
      { id: "p65", name: "" },
      { id: "p66", name: "" },
      { id: "p67", name: "" },
      { id: "p68", name: "" },
      { id: "p69", name: "" },
      { id: "p70", name: "" },
      { id: "p71", name: "" },
    ],
    bonds: [
      { id: "n1-p1", source: "n1", target: "p1", type: 0 },
      { id: "n1-p2", source: "n1", target: "p2", type: 0 },
      { id: "n1-p3", source: "n1", target: "p3", type: 0 },
      { id: "n1-p62", source: "n1", target: "p62", type: 0 },
      { id: "n1-p63", source: "n1", target: "p63", type: 0 },

      { id: "n1-r5", source: "n1", target: "r5", type: 1 },

      { id: "n1-p64", source: "n1", target: "p64", type: 0 },
      { id: "n1-p65", source: "n1", target: "p65", type: 0 },
      { id: "n1-p66", source: "n1", target: "p66", type: 0 },
      { id: "n1-p67", source: "n1", target: "p67", type: 0 },
      { id: "n1-p68", source: "n1", target: "p68", type: 0 },

      { id: "n1-c1", source: "n1", target: "c1", type: 1, multiplier: 2 },

      { id: "n1-p4", source: "n1", target: "p5", type: 0 },
      { id: "n1-p69", source: "n1", target: "p69", type: 0 },
      { id: "n1-p70", source: "n1", target: "p70", type: 0 },
      { id: "n1-p71", source: "n1", target: "p71", type: 0 },

      { id: "c1-p6", source: "c1", target: "p6", type: 0 },
      { id: "c1-p7", source: "c1", target: "p7", type: 0 },
      { id: "c1-p8", source: "c1", target: "p8", type: 0 },
      { id: "c1-p9", source: "c1", target: "p9", type: 0 },
      { id: "c1-p10", source: "c1", target: "p10", type: 0 },

      { id: "c1-r1", source: "c1", target: "r1", type: 1 },

      { id: "c1-p11", source: "c1", target: "p11", type: 0 },
      { id: "c1-p12", source: "c1", target: "p12", type: 0 },
      { id: "c1-p13", source: "c1", target: "p13", type: 0 },
      { id: "c1-p14", source: "c1", target: "p14", type: 0 },
      { id: "c1-p15", source: "c1", target: "p15", type: 0 },

      { id: "c1-c2", source: "c1", target: "c2", type: 2 },

      { id: "c1-p16", source: "c1", target: "p16", type: 0 },
      { id: "c1-p17", source: "c1", target: "p17", type: 0 },
      { id: "c1-p18", source: "c1", target: "p18", type: 0 },
      { id: "c1-p19", source: "c1", target: "p19", type: 0 },

      { id: "c2-p20", source: "c2", target: "p20", type: 0 },
      { id: "c2-p21", source: "c2", target: "p21", type: 0 },
      { id: "c2-p22", source: "c2", target: "p22", type: 0 },
      { id: "c2-p23", source: "c2", target: "p23", type: 0 },
      { id: "c2-p24", source: "c2", target: "p24", type: 0 },

      { id: "c2-r2", source: "c2", target: "r2", type: 1 },

      { id: "c2-p25", source: "c2", target: "p25", type: 0 },
      { id: "c2-p26", source: "c2", target: "p26", type: 0 },
      { id: "c2-p27", source: "c2", target: "p27", type: 0 },
      { id: "c2-p28", source: "c2", target: "p28", type: 0 },
      { id: "c2-p29", source: "c2", target: "p29", type: 0 },

      { id: "c2-c3", source: "c2", target: "c3", type: 1 },

      { id: "c2-p30", source: "c2", target: "p30", type: 0 },
      { id: "c2-p31", source: "c2", target: "p31", type: 0 },
      { id: "c2-p32", source: "c2", target: "p32", type: 0 },
      { id: "c2-p33", source: "c2", target: "p33", type: 0 },

      { id: "c3-p34", source: "c3", target: "p34", type: 0 },
      { id: "c3-p35", source: "c3", target: "p35", type: 0 },
      { id: "c3-p36", source: "c3", target: "p36", type: 0 },
      { id: "c3-p37", source: "c3", target: "p37", type: 0 },
      { id: "c3-p38", source: "c3", target: "p38", type: 0 },

      { id: "c3-r3", source: "c3", target: "r3", type: 1 },

      { id: "c3-p39", source: "c3", target: "p39", type: 0 },
      { id: "c3-p40", source: "c3", target: "p40", type: 0 },
      { id: "c3-p41", source: "c3", target: "p41", type: 0 },
      { id: "c3-p42", source: "c3", target: "p42", type: 0 },
      { id: "c3-p43", source: "c3", target: "p43", type: 0 },

      { id: "c3-c4", source: "c3", target: "c4", type: 2 },

      { id: "c3-p44", source: "c3", target: "p44", type: 0 },
      { id: "c3-p45", source: "c3", target: "p45", type: 0 },
      { id: "c3-p46", source: "c3", target: "p46", type: 0 },
      { id: "c3-p47", source: "c3", target: "p47", type: 0 },

      { id: "c4-p48", source: "c4", target: "p48", type: 0 },
      { id: "c4-p49", source: "c4", target: "p49", type: 0 },
      { id: "c4-p50", source: "c4", target: "p50", type: 0 },
      { id: "c4-p51", source: "c4", target: "p51", type: 0 },
      { id: "c4-p52", source: "c4", target: "p52", type: 0 },

      { id: "c4-r4", source: "c4", target: "r4", type: 1 },

      { id: "c4-p53", source: "c4", target: "p53", type: 0 },
      { id: "c4-p54", source: "c4", target: "p54", type: 0 },
      { id: "c4-p55", source: "c4", target: "p55", type: 0 },
      { id: "c4-p56", source: "c4", target: "p56", type: 0 },
      { id: "c4-p57", source: "c4", target: "p57", type: 0 },

      { id: "c4-n1", source: "c4", target: "n1", type: 1, multiplier: 2 },

      { id: "c4-p58", source: "c4", target: "p58", type: 0 },
      { id: "c4-p59", source: "c4", target: "p59", type: 0 },
      { id: "c4-p60", source: "c4", target: "p60", type: 0 },
      { id: "c4-p61", source: "c4", target: "p61", type: 0 },
    ],
  },
  aldehyde: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "o1", name: "O" },
      { id: "h1", name: "H" },
      { id: "r1", name: "R" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 2 },
      { id: "c1-h1", source: "c1", target: "h1", type: 1 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
    ],
  },
  ketone: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "o1", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 2 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
    ],
  },
  ether: {
    atoms: [
      { id: "o1", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "p1" },
    ],
    bonds: [
      { id: "o1-r1", source: "o1", target: "r1", type: 1 },
      { id: "o1-r2", source: "o1", target: "r2", type: 1 },
      { id: "o1-p1", source: "o1", target: "p1", type: 0 },
    ],
  },
  alcohol: {
    atoms: [
      { id: "o1", name: "O" },
      { id: "h1", name: "H" },
      { id: "r1", name: "R" },
      { id: "p1" },
    ],
    bonds: [
      { id: "o1-r1", source: "o1", target: "r1", type: 1 },
      { id: "o1-h1", source: "o1", target: "h1", type: 1 },
      { id: "o1-p1", source: "o1", target: "p1", type: 0 },
    ],
  },
  amine: {
    atoms: [
      { id: "n1", name: "N" },
      { id: "r1", name: "R" },
      { id: "h1", name: "H" },
      { id: "h2", name: "H" },
    ],
    bonds: [
      { id: "n1-r1", source: "n1", target: "r1", type: 1 },
      { id: "n1-h1", source: "n1", target: "h1", type: 1 },
      { id: "n1-h2", source: "n1", target: "h2", type: 1 },
    ],
  },
  "carboxylic-acid": {
    atoms: [
      { id: "c1", name: "C" },
      { id: "o1", name: "O" },
      { id: "o2", name: "O" },
      { id: "h1", name: "H" },
      { id: "r1", name: "R" },
      { id: "p1", name: "" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 2 },
      { id: "c1-o2", source: "c1", target: "o2", type: 1 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "o2-h1", source: "o2", target: "h1", type: 1 },
      { id: "o2-p1", source: "o2", target: "p1", type: 0 },
    ],
  },
  amide: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "o1", name: "O" },
      { id: "n1", name: "N" },
      { id: "r1", name: "R" },
      { id: "h1", name: "H" },
      { id: "r2", name: "R" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 2 },
      { id: "c1-n1", source: "c1", target: "n1", type: 1 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "n1-r2", source: "n1", target: "r2", type: 1 },
      { id: "n1-h1", source: "n1", target: "h1", type: 1 },
    ],
  },
  ester: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "o1", name: "O" },
      { id: "o2", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "p1" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 2 },
      { id: "c1-o2", source: "c1", target: "o2", type: 1 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "o2-r2", source: "o2", target: "r2", type: 1 },
      { id: "o2-p1", source: "o2", target: "p1", type: 0 },
    ],
  },
  nitrile: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "n1", name: "N" },
      { id: "r1", name: "R" },
    ],
    bonds: [
      { id: "c1-n1", source: "c1", target: "n1", type: 3 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
    ],
  },
  alkene: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
      { id: "r4", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
      { id: "c1-c2", source: "c1", target: "c2", type: 2 },
      { id: "c2-r3", source: "c2", target: "r3", type: 1 },
      { id: "c2-r4", source: "c2", target: "r4", type: 1 },
    ],
  },
  alkyne: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "c2", name: "C" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-c2", source: "c1", target: "c2", type: 3 },
      { id: "c2-r2", source: "c2", target: "r2", type: 1 },
    ],
  },
  alkyl: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "h1", name: "H" },
    ],
    bonds: [{ id: "c1-h1", source: "c1", target: "h1", type: 1 }],
  },
  "c-o": {
    atoms: [
      { id: "c1", name: "C", angle: 90 },
      { id: "o1", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
    ],
    bonds: [
      { id: "c1-o1", source: "c1", target: "o1", type: 1 },
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
      { id: "c1-r3", source: "c1", target: "r3", type: 1 },
    ],
  },
  oxygen: {
    atoms: [
      { id: "o1", name: "O" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "p1" },
    ],
    bonds: [
      { id: "o1-r1", source: "o1", target: "r1", type: 1 },
      { id: "o1-r2", source: "o1", target: "r2", type: 1 },
      { id: "o1-p1", source: "o1", target: "p1", type: 0 },
    ],
  },
  nitrogen: {
    atoms: [
      { id: "n1", name: "N" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
    ],
    bonds: [
      { id: "n1-r1", source: "n1", target: "r1", type: 1 },
      { id: "n1-r2", source: "n1", target: "r2", type: 1 },
      { id: "n1-r3", source: "n1", target: "r3", type: 1 },
    ],
  },
  carbon: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "r1", name: "R" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
      { id: "r4", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
      { id: "c1-r3", source: "c1", target: "r3", type: 1 },
      { id: "c1-r4", source: "c1", target: "r4", type: 1 },
    ],
  },
  hydrogen: {
    atoms: [
      { id: "h1", name: "H", label: true },
      { id: "r1", name: "R" },
    ],
    bonds: [{ id: "h1-r1", source: "h1", target: "r1", type: 1 }],
  },
  flourine: {
    atoms: [
      { id: "f1", name: "F", angle: 90 },
      { id: "r1", name: "R" },
    ],
    bonds: [{ id: "f1-r1", source: "f1", target: "r1", type: 1 }],
  },
  chlorine: {
    atoms: [
      { id: "Cl1", name: "Cl", angle: 90 },
      { id: "r1", name: "R" },
    ],
    bonds: [{ id: "Cl1-r1", source: "Cl1", target: "r1", type: 1 }],
  },
  bromine: {
    atoms: [
      { id: "br1", name: "Br", angle: 90 },
      { id: "r1", name: "R" },
    ],
    bonds: [{ id: "br1-r1", source: "br1", target: "r1", type: 1 }],
  },
  iodine: {
    atoms: [
      { id: "i1", name: "I", angle: 90 },
      { id: "r1", name: "R" },
    ],
    bonds: [{ id: "i1-r1", source: "i1", target: "r1", type: 1 }],
  },
  no2: {
    atoms: [
      { id: "n1", name: "N", angle: -90 },
      { id: "o1", name: "O" },
      { id: "o2", name: "O" },
      { id: "r1", name: "R" },
    ],
    bonds: [
      { id: "n1-r1", source: "n1", target: "r1", type: 1 },
      { id: "n1-o1", source: "n1", target: "o1", type: 1 },
      { id: "n1-o2", source: "n1", target: "o2", type: 1 },
    ],
  },
  ch: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "r1", name: "R" },
      { id: "h1", name: "H" },
      { id: "r2", name: "R" },
      { id: "r3", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-h1", source: "c1", target: "h1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
      { id: "c1-r3", source: "c1", target: "r3", type: 1 },
    ],
  },
  ch2: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "r1", name: "R" },
      { id: "h1", name: "H" },
      { id: "h2", name: "H" },
      { id: "r2", name: "R" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-h1", source: "c1", target: "h1", type: 1 },
      { id: "c1-r2", source: "c1", target: "r2", type: 1 },
      { id: "c1-h2", source: "c1", target: "h2", type: 1 },
    ],
  },
  ch3: {
    atoms: [
      { id: "c1", name: "C" },
      { id: "r1", name: "R" },
      { id: "h1", name: "H" },
      { id: "h2", name: "H" },
      { id: "h3", name: "H" },
    ],
    bonds: [
      { id: "c1-r1", source: "c1", target: "r1", type: 1 },
      { id: "c1-h1", source: "c1", target: "h1", type: 1 },
      { id: "c1-h2", source: "c1", target: "h2", type: 1 },
      { id: "c1-h3", source: "c1", target: "h3", type: 1 },
    ],
  },
  empty: {
    atoms: [],
    bonds: [],
  },
};
